import Icon1 from "assets/images/cases/nykart/icons/ico_1.svg";
import Icon2 from "assets/images/cases/nykart/icons/ico_2.svg";
import Icon3 from "assets/images/cases/nykart/icons/ico_3.svg";
import Icon4 from "assets/images/cases/nykart/icons/ico_4.svg";
import Icon5 from "assets/images/cases/nykart/icons/ico_5.svg";
import Icon6 from "assets/images/cases/nykart/icons/ico_6.svg";

// icons todo
import VueIcon from "assets/images/technologies/vue.svg";
import Image from "gatsby-image";
import React from "react";
import {useTeamPhotos} from "shared/Hooks/About/Team";
import {NykartImages} from "./NykartImages";

export const NykartData = () => {
  const images = NykartImages();
  const team_images = useTeamPhotos();

  return {
    color:          "#D59E33",
    title:          "Nykart",
    seo:
                    "Zaprojektowaliśmy elegancki i designerski projekt witryny, który w szczegółowy sposób pokazuje działalność marki.",
    slug:           "nykart",
    hero:           {
      title:      "Stolarstwo w nowoczesnym wydaniu.",
      color:      "#D59E33",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    list:           {
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did:    {
      title:        "Strona internetowa stylowa jak meble",
      technologies: [
        "Strony WWW",
        "UX Workshops",
        "Identyfikacja wizualna",
        "Fotografia produktowa",
      ],
      text:
                    "Stworzenie nowej strony internetowej dla artystycznej pracowni meblarskiej NYKart, która jest połączeniem tradycji i innowacji, to nie lada wyzwanie. Zaprojektowaliśmy elegancki i designerski projekt witryny, który w szczegółowy sposób pokazuje działalność marki. Podczas naszej pracy skupiliśmy się przede wszystkim na ukazaniu walorów i atutów marki NYKart oraz zaprezentowaniu oryginalności stolarstwa artystycznego w formie autorskich fotografii.",
      list:         [
        "Opracowaliśmy branding marki",
        "Zaprojektowaliśmy i zakodowaliśmy stronę internetową",
        "Wykonaliśmy fotograficzną sesję produktową i aranżacyjną",
        "Opracowaliśmy schemat działań social media",
        "Wykorzystaliśmy autorski system CMS do zarządzania treścią ",
      ],
    },
    logo:           {
      first: (
               <Image
                 alt=""
                 objectPosition={"center"}
                 objectFit={"contain"}
                 fluid={images.logo.childImageSharp.fluid}
               />
             ),
    },
    headers:        {
      first:  "Połączenie elegancji i designu",
      second: "Strona internetowa wierna idei marki",
    },
    icons:          [Icon1, Icon2, Icon3, Icon4, Icon5, Icon6],
    content_images: {
      first:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.nyk_1.childImageSharp.fluid}
                />
              ),
      second: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.nyk_2.childImageSharp.fluid}
                />
              ),
      third:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.nyk_3.childImageSharp.fluid}
                />
              ),
      fourth: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.nyk_4.childImageSharp.fluid}
                />
              ),
    },
    full_images:    {
      first:  {
        title: "Nowoczesne meble, nowoczesna strona",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_1f.childImageSharp.fluid}
                 />
               ),
      },
      second: {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_2f.childImageSharp.fluid}
                 />
               ),
      },
      third:  {
        title: " ",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_3f.childImageSharp.fluid}
                 />
               ),
      },
      fourth: {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_4f.childImageSharp.fluid}
                 />
               ),
      },
      fifth:  {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_5f.childImageSharp.fluid}
                 />
               ),
      },
      sixth:  {
        title: "",
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.nyk_6f.childImageSharp.fluid}
                 />
               ),
      },
    },
    text_boxes:     {
      first:  {
        title: "Witryna, która odzwierciedla charakter marki ",
        text:
               "Zaprojektowana strona internetowa całkowicie odpowiada stylowi marki. Zamieszczone zdjęcia produktów oraz nowe logo przedstawiają użytkownikom ofertę firmy NYKart i zachęcają do kontaktu z nią. Zachowana spójność i jednolitość elementów pokazuje markę w profesjonalny i unikatowy sposób.",
      },
      second: {
        title: "Nowoczesne rozwiązania w stolarstwie artystycznym",
        text:
               "Zoptymalizowaliśmy stronę pod kątem przeglądarek internetowych oraz wykorzystaliśmy autorski system CMS do zarządzania treścią. Dzięki temu witryna jest w pełni responsywna i dostosowana do urządzeń mobilnych, co znacznie ułatwia korzystanie z niej. ",
      },
      third:  {
        title: "Spójny branding marki",
        text:
               "Skupiliśmy się na pokazaniu zamiłowania projektantów mebli do drewna, metalu, absolutnej prostoty i umiaru. Na stronie dominuje energetyzujący żółty kolor, który idealnie kontrastuje z białym tłem i czarną stopką. Zachowanie spójnej kolorystyki podkreśla wiarygodność i konsekwencję w komunikacji marki z jej odbiorcami.",
      },
      fourth: {
        title: "Profesjonalne zdjęcia wysokiej jakości",
        text:
               "Wykonaliśmy również fotografie produktowe, które zamieściliśmy na stronie internetowej. Zdjęcia samych produktów przedstawione są we współczesnej aranżacji. Podkreślają również wyjątkowość wykonywanych przez NYKart mebli i ukazują je jako niezwykle unikatowe i wysokiej jakości artykuły. ",
      },
      fifth:  {
        title: "NYKart – artystyczne logo",
        text:
               "Opracowaliśmy również nową identyfikację wizualną, czego efektem było nowe logo firmy. Nawiązuje ono do oferty marki NYKart raz jej założycieli, którzy bez wątpienia są twarzą brandu.  Logo jest zachowane w klimacie marki, jest proste i minimalistyczne, jednak przekazuje najważniejsze komunikaty.",
      },
    },
    gallery:        {
      first: [
        <Image alt="" fluid={images.nyk_1g.childImageSharp.fluid}/>,
        <Image alt="" fluid={images.nyk_2g.childImageSharp.fluid}/>,
      ],
    },
    technologies:   {
      title: "Podczas pracy nad tym projektem, korzystaliśmy z:",
      text:
             "Wykonane przez nas prace są spójne i w pełni odzwierciedlają charakter marki. Zdjęcia produktów i nowe logo podkreślają unikatowość i oryginalność usługi, jaką jest stolarstwo artystyczne. Są odpowiedzią na potrzeby użytkowników. ",
      icons: [
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
        {title: "Vue", icon: VueIcon},
      ],
    },
    marketing:      {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team:   [
        {
          name:     "Patrycja Bilska",
          position: "Project Manager",
          image:    (
                      <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid}/>
                    ),
        },
        {
          name:     "Rafał Skórka",
          position: "Frontend Developer",
          image:    (
                      <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid}/>
                    ),
        },
        {
          name:     "Patryk Białas",
          position: "Graphic designer",
          image:    (
                      <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid}/>
                    ),
        },
        {
          name:     "Rafał Krawiec",
          position: "Backend Developer",
          image:    (
                      <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid}/>
                    ),
        },
        {
          name:     "Jakub Żmuda",
          position: "Marketing Specialist",
          image:    (
                      <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid}/>
                    ),
        },
        {
          name:     "Jakub Furman",
          position: "Sales Manager",
          image:    (
                      <Image alt="" fluid={team_images.Furman.childImageSharp.fluid}/>
                    ),
        },
      ],
    },
  };
};
